import { DeviceType } from '@kinderlabs-pos/shared-data-type';
import {
	DdiziState,
	OrderState,
	PosElectronStoreState,
	PrintReceiptState,
	StoreInfoState,
} from '@kinderlabs-pos/state';
import { atom, useAtom, useAtomValue, useSetAtom } from 'jotai';
import { atomWithReset, useResetAtom } from 'jotai/utils';
import { useEffect } from 'react';
import { MappingTicketQuery } from '../../../mappingTicket/mappingTicketQuery';
import { useQuery } from '@tanstack/react-query';

let timeout1: NodeJS.Timeout | null = null;
const curPrintingIdxAtom = atomWithReset(0);
const pausedAtom = atom(true);

export const VaunceDdiziPrintEventHandler = ({
	deviceType,
	orderId,
}: {
	deviceType: DeviceType;
	orderId: string;
}) => {
	const ddizis = useAtomValue(OrderState.printing.ddizis.printing);
	const [paused, setPaused] = useAtom(pausedAtom);
	useEffect(() => {
		setPaused(true);
	}, []);
	const { data: mappingTicketData } = useQuery({
		...MappingTicketQuery.query.mappingTicket.getTicketMappingInfoForOrders(orderId),
		suspense: false,
	});

	const { storeId } = useAtomValue(StoreInfoState.curStoreAndDevice);
	const storeInfo = useAtomValue(StoreInfoState.curStoreInfo);
	const curDeviceInfo = StoreInfoState.useCurDeviceInfoForOrder();

	const localSettings = PosElectronStoreState.usePosMainPageLocalSettings().data;

	// 이따 리팩토링할 것
	const [curIdx, setCurIdx] = useAtom(curPrintingIdxAtom);
	const resetAtom = useResetAtom(curPrintingIdxAtom);
	useEffect(() => {
		return () => {
			resetAtom();
		};
	}, []);

	const 바운스띠지프린터라벨출력 = PrintReceiptState.LabelPrinter.usePrintLabelPrinter({
		labelPrinterList: curDeviceInfo.labelPrinterList,
	});

	const changeStatus = useSetAtom(OrderState.printing.ddizis.changeStatus);

	useEffect(() => {
		if (paused) return;
		if (ddizis.length === 0 || curIdx >= ddizis.length) return;
		// IPC Send 는 여기서
		// sendTicketPrinterMessage({ ticket 정보 })

		const ddiziToPrint = ddizis[curIdx];

		// 2번씩 rerendering 되는 문제가 발견되어서 조치
		if (ddiziToPrint.printStatus === 'ON') return;
		timeout1 = setTimeout(async () => {
			changeStatus({
				id: ddiziToPrint.id,
				printingStatus: 'ON',
			});
			const ddiziData = { ...DdiziState.utils.getDdizi인쇄Data(ddiziToPrint) };

			const 권종 = ddiziData.message.labelName.includes('키즈')
				? '키즈'
				: ddiziData.message.labelName.includes('보호자')
				? '보호자'
				: '일반';

			const mappingMember = mappingTicketData?.find(
				(item) => item.mappedTicketId === ddiziToPrint.id
			);

			try {
				const result = await 바운스띠지프린터라벨출력({
					...ddiziData,
					deviceType,
					...PrintReceiptState.LabelPrinter.getDesignOptions({
						localSettings,
						deviceNum: ddiziData.deviceNum,
					}),
					storeName: storeInfo.name,
					modelName:
						curDeviceInfo.labelPrinterList.find((p) => p.logicalName === ddiziData.deviceNum)
							?.modelName ?? '',
					meta: {
						고객명: mappingMember?.name,
						생년월일: mappingMember?.birth,
						성별: mappingMember?.gender,
						권종,
					},
				});

				changeStatus({
					id: ddiziToPrint.id,
					printingStatus: 'COMPLETE',
				});

				setCurIdx((state) => state + 1);
			} catch {
				changeStatus({
					id: ddiziToPrint.id,
					printingStatus: 'FAILED',
				});

				setPaused(true);
			}
		}, 1000);

		return () => {
			timeout1 && clearTimeout(timeout1);
		};
	}, [ddizis, curIdx, paused]);

	// 이건 clear 하는건데, 시점을 언제로 잡아야 좋을지ㅋㅋ

	return null;
};

VaunceDdiziPrintEventHandler.useIsPaused = () => {
	return useAtomValue(pausedAtom);
};
VaunceDdiziPrintEventHandler.usePause = () => {
	const setPaused = useSetAtom(pausedAtom);

	return () => setPaused(true);
};

VaunceDdiziPrintEventHandler.useResume = () => {
	const setPaused = useSetAtom(pausedAtom);
	return () => {
		setPaused(false);
	};
};
